import { FpjsClient } from '@fingerprintjs/fingerprintjs-pro-spa'
import { ECurrency } from '@lbs/currency'
import Decimal from 'decimal.js'
import { isEmpty } from 'lodash'
import {
  action,
  autorun,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx'
import fingerPrintLoadOptions from '../constants/fingerPrint'
import { ListGamesStore } from './ListGames.store'
import { LoginStore } from './Login.store'
import {
  BalanceEventResponse,
  SOCKET_COVER_EVENTS,
  SocketCover,
} from './SocketCover.store'

export class ApplicationStore {
  private socket: SocketCover | null = null

  loginStore: LoginStore

  listGamesStore: ListGamesStore

  version: string = ''

  balance: string = '0.00'

  availableBalance: string = '0.00'

  currency: ECurrency = ECurrency.RUB

  gameRatio: number = 0

  isOffline: boolean = false

  fpJsClient: FpjsClient | null = null

  constructor(loginStore: LoginStore, listGamesStore: ListGamesStore) {
    this.loginStore = loginStore

    this.listGamesStore = listGamesStore

    this.fpJsClient = fingerPrintLoadOptions.apiKey
      ? new FpjsClient({
          loadOptions: {
            ...fingerPrintLoadOptions,
          },
        })
      : null

    makeObservable(this, {
      loginStore: observable,
      listGamesStore: observable,
      balance: observable,
      availableBalance: observable,
      currency: observable,
      gameRatio: observable,
      version: observable,
      isOffline: observable,
      setBalance: action,
      reset: action,
      balanceWithSpace: computed,
    })

    autorun(() => {
      if (this.loginStore.accessToken) {
        this.initSocketCover()
      } else {
        this.destroySocketCover()
      }
    })
  }

  initSocketCover = (): void => {
    if (!isEmpty(this.socket)) this.destroySocketCover()

    if (this.socket?.accessToken === this.loginStore.accessToken) return

    this.socket = new SocketCover(this.loginStore.accessToken)

    this.socket.io?.on(
      SOCKET_COVER_EVENTS.BALANCE,
      (data: BalanceEventResponse) => {
        runInAction(() => {
          this.balance = data.balance
          this.availableBalance = data.availableBalance
          this.currency = data.currency
          this.gameRatio = data.gameRatio
        })
      }
    )

    this.socket.io?.on(SOCKET_COVER_EVENTS.DISC_AND_LOGOUT, async () => {
      await this.loginStore.logout()
    })

    this.socket.io?.on(SOCKET_COVER_EVENTS.ANOTHER_AUTH, async () => {
      await this.loginStore.logout()
    })

    this.socket.io?.on(SOCKET_COVER_EVENTS.CHANGE_STATUS_GAME, async () => {
      await this.listGamesStore.fetchGameScheduleRoulette()
    })
  }

  destroySocketCover = (): void => {
    this.socket?.destroy()

    this.socket = null
  }

  reset = (): void => {
    this.balance = '0.00'
    this.availableBalance = '0.00'
    this.currency = ECurrency.RUB
    this.gameRatio = 0

    this.destroySocketCover()
  }

  setBalance = (data: BalanceEventResponse): void => {
    this.balance = data.balance
    this.availableBalance = data.availableBalance
    this.currency = data.currency
    this.gameRatio = data.gameRatio
  }

  setIsOffline = (data: boolean): void => {
    this.isOffline = data
  }

  get balanceWithSpace(): string {
    const parts = new Decimal(this.balance).toFixed(2).split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    return parts.join('.')
  }
}
